module.exports = __webpack_public_path__ + "static/img/symbol_logo.345a48ec.png";